import { useParams } from 'react-router-dom'

export function useFamilyParameter() {
  const { family } = useParams<{family:string}>();
  return family;
}
